// Ionic
import {
  IonLabel,
  IonItem,
  IonInput,
  IonIcon,
  IonGrid,
  IonCol,
  IonRow,
  IonButton,
} from "@ionic/react";

import { close, timerOutline, search, compassOutline } from "ionicons/icons";

function SearchInput(props) {
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    props.onSearchSubmit(e.target.value);
  };

  const getLocation = (e) => {
    console.log("get location");
    console.log(navigator.geolocation);
    navigator.geolocation.getCurrentPosition((position) => {
      console.log(position);
      document.getElementById("searchinput").setAttribute("data-lat",position.coords.latitude);
      document.getElementById("searchinput").setAttribute("data-lng",position.coords.longitude);
      props.setSearchText("Kartenbereich");
      //props.centerMap(position.coords.latitude, position.coords.longitude);
      window.gmap.setZoom(11);
      handleSearchSubmit(e);
    });
  };

  const handleSearchTextChange = (e) => {
    props.onSearchTextChange(e.target.value);
  };

  const handleSearchFocus = () => {
    props.onSearchFocus();
  };

  const handleSearchBlur = () => {
    props.onSearchBlur();
  };

  return (
    <div>
      <form onSubmit={handleSearchSubmit}>
        <IonItem fill="solid" className="search__input">
          <IonLabel position="floating" color="medium">
          Ort, Region, PLZ (+Land), POI
          </IonLabel>
          <IonInput
            value={props.value}
            className="search__input"
            id="searchinput"
            enterkeyhint="search"
            onIonChange={handleSearchTextChange}
            onIonFocus={handleSearchFocus}
            onIonBlur={handleSearchBlur}
            onClick={() => props.onSearchFocus()}
          >
            {" "}

          </IonInput>

          <input type ="hidden" id="lat" value="" />
          <input type ="hidden" id="lng" value="" />
          <IonButton onClick={handleSearchSubmit} color="primary" className="search__button" shape="round">
              <IonIcon icon={search} color="light" />{" "}
            </IonButton>
            <IonButton onClick={getLocation} color="dark" className="location__button" shape="round">
              <IonIcon icon={compassOutline} color="light" />{" "}
            </IonButton>
        </IonItem>

      </form>

      <div
        className={`${
          props.previousVisibleValue ? "show" : "hide"
        } form__overlay`}
      >
        <>
          <p className="form__heading">
            <b>Zuletzt gesucht</b>
          </p>
          <hr className="form__divider"></hr>
          {props.previousSearchValue.slice(0, 3).map((item) => {
            return (
              <IonGrid key={item}>
                <IonRow className="ion-align-items-center">
                  <IonCol size="10">
                    {" "}
                    <IonItem
                      button
                      onClick={() => props.onPreviousSelect(item)}
                      className="form__item"
                    >
                      <IonIcon icon={timerOutline} color="secondary" />
                      {item}
                    </IonItem>
                  </IonCol>
                  <IonCol size="2">
                    {" "}
                    <IonIcon
                      icon={close}
                      onClick={() => props.deletePreviousSelect(item)}
                    />
                  </IonCol>
                </IonRow>
              </IonGrid>
            );
          })}
          {/*          <p className="form__heading"><b>Aus Merkliste</b></p>
          <hr className="form__divider"></hr>*/}

          {/* {props.bookmarkValue.lists[0]["items"].slice(0, 3).map((item) => {
            return (
              <>
                <IonGrid>
                  <IonRow className="ion-align-items-center">
                    <IonCol size="10">
                      {" "}
                      <IonItem
                        button
                        onClick={() => props.onPreviousSelect(item.name)}
                        className="form__item"

                      >
                      <IonIcon icon={timerOutline} color="secondary"/>
                        {item.name}
                         ÄNDERN IN DATEN DIE GESCHICKT WERDEN
                      </IonItem>
                    </IonCol>
                    <IonCol size="2">
                      {" "}
                      <IonIcon
                        icon={close}
                        onClick={() => props.deletePreviousSelect(item.name)}
                      />
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </>
            );
          })}*/}
        </>
      </div>
    </div>
  );
}

export default SearchInput;
